import { InputRightElement as BaseInputRightElement } from "@chakra-ui/react";

export default BaseInputRightElement;
